<template>
  <div class="row wrapper border-bottom white-bg page-heading mb-2">
    <div class="col-lg-8 align-self-center">
      <div class="d-flex align-self-center justify-content-between">      
        <h2>{{ $t('navigations.key risk indicator') }}</h2>
      </div>
    </div>
  </div>
  <!-- Main Content -->
  <div class="ibox-content">
    <!-- Upload Panel -->
    <!-- <div class="upload-card" id="uploadPanel">
            <div class="ibox-content"> -->
    <!-- File Upload Area -->
    <!-- <div class="file-drop-area" id="dropArea">
                    <h4><i class="fa fa-cloud-upload"></i> Select or Drop your RACT file here</h4>
                    <p class="text-muted mb-2">Supports .xlsx and .xls formats</p>
                    <button class="btn btn-sm btn-outline-primary px-2 py-0 mb-2">
                        Browse Files
                    </button>
                    <input type="file" id="fileInput" class="d-none" accept=".xlsx, .xls">
                </div> -->
 
    <!-- File Preview -->
    <!-- <div class="file-preview d-none" id="filePreview">
                    <div class="file-info">
                        <h6 id="fileName">No file selected</h6>
                        <p id="fileSize">-</p>
                    </div>
                </div> -->
 
    <!-- Validation Result -->
    <!-- <div class="validation-result alert alert-info d-none" id="validationResult">
                    <div class="align-items-center">
                        <div>
                            <h5 class="alert-heading">Ready to Validate</h5>
                            <p class="mb-0">Your file is ready for validation. Click the button below to start.</p>
                        </div>
                    </div>
                </div> -->
 
    <!-- Action Button -->
    <!-- <div class="text-center mt-2">
                    <button class="btn btn-upload btn-lg" id="uploadBtn">
                        <span id="btnText">Validate & Upload RACT File</span>
                        <span id="btnSpinner" class="d-none">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Validating...
                        </span>
                    </button>
                </div> -->
 
    <!-- RACT Information -->
 
    <!-- </div>
        </div> -->
 
    <!-- Success Panel (hidden initially) -->
    <!-- <div class="success-panel d-none" id="successPanel">
            <div class="d-flex align-items-center">
                <div>
                    <h6 class="text-success">RACT File Successfully Processed!</h6>
                    <p class="mb-0">Your RACT file has been validated and imported. You can now view and edit the risk
                        assessment data below.</p>
                </div>
            </div>
        </div> -->
 
    <!-- Data Grid Panel (hidden initially) -->
    <div class="ibox-content data-grid-container">
      <div class="data-grid-header">
        <h6 class="mb-0">
          <i class="fa fa-table me-2"></i>
          {{ $t("navigations.key risk indicator") }}
        </h6>
            <div
              class="position-relative align-self-center"
            >
              <img
              class="cursor-pointer"
              src="../../assets/img/create.png"
              width="17"
              height="17"
              alt="Create risk assessment data"
              @click="openCreateRiskModals"
              />
              <div class="tool-tip">{{ $t("navigations.create key risk indicator") }}</div>
            </div>
      </div>
      <div class="table-responsive">
        <table class="table table-striped dark-table-head mb-0">
          <thead>
            <tr>
              <th>{{ $t("navigations.category id") }}</th>
              <th>{{ $t("navigations.category") }}</th>
              <th>{{ $t("navigations.subcategory") }}</th>
              <th>{{ $t("navigations.description") }}</th>
              <th>{{ $t("navigations.level of scrutiny") }}</th>
              <!-- <th>{{ $t("navigations.risk level") }}</th> -->
              <th>{{ $t("navigations.edit") }}</th>
              <th>{{ $t("navigations.actions") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in ractlist" :key="item.id">
              <td class="py-0">{{ item.categoryId }}</td>
              <td class="py-1">
                {{ item.category }}
              </td>
              <td class="py-1">
                {{ item.subCategory }}
              </td>
              <td class="py-1">
                <div v-if="!showMoreDescription[item.id]">
                  <span>
                    {{
                      item.discussionDetails
                        ? item.discussionDetails.substring(0, 30)
                        : ""
                    }}
                  </span>
                  <span
                    class="cursor-pointer more-block"
                    v-if="
                      item.discussionDetails &&
                      item.discussionDetails.length > 30
                    "
                    @click="showMoreDescription[item.id] = true"
                    >...More</span
                  >
                </div>
                <div v-else>
                  <span>{{ item.discussionDetails }}</span>
                  <span
                    class="cursor-pointer text-primary ms-1"
                    @click="showMoreDescription[item.id] = false"
                    >Show Less</span
                  >
                </div>
              </td>
              <td class="py-1">
                {{ item.levelOfScrutiny }}
              </td>
              <!-- <td class="py-1">
                <select
                  class="form-select form-select-sm risk-level-select"
                  :class="{
                    'risk-low': item.riskLevel === 'Low',
                    'risk-medium': item.riskLevel === 'Medium',
                    'risk-high': item.riskLevel === 'High',
                  }"
                  v-model="item.riskLevel"
                >
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                  <option value="High">High</option>
                </select>
              </td> -->
              <td class="py-1">
                <button
                  class="btn text-primary py-0 me-1"
                  @click="EditRact(item.id)"
                >
                  <i class="fa fa-edit"></i>
                </button>
              </td>
              <td class="action-buttons py-1">
                <button class="btn text-danger py-0">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
            <tr v-if="!ractlist.length">
              <td colspan="7" class="text-center text-muted">
                No data available
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-lg-12 d-flex justify-content-lg-end px-0 mt-1">
        <v-pagination
          v-model="currentTemplatePage"
          :pages="totalTemplatePages"
          :range-size="0"
          active-color="#f4f9ff"
          @update:modelValue="LoadData"
        />
      </div>
      <div class="d-flex justify-content-end mt-4">
        <!-- <div>
          <button class="btn btn-sm btn-outline-primary">Add New Risk</button>
        </div> -->
        <div>
          <button class="btn btn-sm btn-outline-primary me-2">Export</button>
        </div>
      </div>
    </div>
  </div>
  <customModal
    v-if="openCreateRiskModal"
    :containermd="true"
    :footerShow="false"
   
     @closeModal="closeModal"
  >
    <template #title>
      <div class="d-flex justify-content-between align-items-center">
        <span>Create Key Risk Indicator</span>
      </div>
    </template>
    <template #body>
      <div class="form-group row px-3 py-2">
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.category id") }}</label>
          <input type="text" class="form-control" v-model="value.categoryId">
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.category") }}</label>
          <input type="text" class="form-control" v-model="value.category">
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.sub category") }}</label>
          <input type="text" class="form-control" v-model="value.subCategory">
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.level of scrutiny") }}</label>
          <input type="text" class="form-control" v-model="value.levelOfScrutiny">
        </div>
        <div class="col-lg-12 mb-1">
          <label class="col-form-label">{{ $t("navigations.description") }}</label>
          <textarea name="" id="" cols="30"  v-model="value.discussionDetails" rows="5"></textarea>
        </div>
        <div class="col-lg-12 my-3 d-flex justify-content-end">
          <button
            class="cancel_btn py-1 px-4 mx-3"
            type="button"
            @click="clear()"
          
          >
            {{ $t("navigations.clear") }}
          </button>
          <button
            class="btn btn-primary py-1 px-4"
            type="submit"
             @click="saveClicked()"
         
          >
            {{ $t("navigations.save") }}
          </button>
        </div>
      </div>
    </template>
  </customModal>
   <customModal
    v-if="editRiskModal"
    :containermd="true"
    :footerShow="false"
    @closeModal="closeModal"
  >
    <template #title>
      <div class="d-flex justify-content-between align-items-center">
        <span>Edit Key Risk Indicator</span>
      </div>
    </template>
    <template #body>
      <div class="form-group row px-3 py-2">
         <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.category id") }}</label>
          <input type="text" class="form-control" v-model="value.categoryId">
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.category") }}</label>
          <input type="text" class="form-control" v-model="value.category">
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.sub category") }}</label>
          <input type="text" class="form-control" v-model="value.subCategory">
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.level of scrutiny") }}</label>
          <input type="text" class="form-control" v-model="value.levelOfScrutiny">
        </div>
        <div class="col-12 mb-1">
          <label class="col-form-label">{{ $t("navigations.description") }}</label>
          <textarea name="" id="" cols="30"  v-model="value.discussionDetails" rows="5"></textarea>
         
        </div>
        <div class="col-lg-12 my-3 d-flex justify-content-end">
          <button
            class="cancel_btn py-1 px-4 mx-3"
            type="button"
            @click="clear()"
          
          >
            {{ $t("navigations.clear") }}
          </button>
          <button
            class="btn btn-primary py-1 px-4"
            type="submit"
             @click="updatedClicked()"
         
          >
            {{ $t("navigations.save") }}
          </button>
        </div>
      </div>
    </template>
  </customModal>
  </template>
 <!-- <script src="./RactFileImport.js"></script>  -->
  <script>
/* eslint-disable */
import VPagination from "@hennge/vue3-pagination";
import axios from "axios";
import store from "../../store/index";
import CustomModal from "../customModal/customModal.vue";
export default {
  name: "RactFileImport",
  components: {
    VPagination,
    CustomModal,
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      idtoken: "",
      totalCount: 0,
      pageindex: 1,
      pagesize: 10,
      value: {
        categoryId: "",
        category: "",
        subCategory: "",
        levelOfScrutiny: "",
        discussionDetails: "",
      },
      SortProperty: "createdDate",
      SortOrder: "desc",
      ractlist: [],
      currentTemplatePage: 1,
      totalTemplatePages: 1,
      openCreateRiskModal: false,
      editRiskModal: false,
      showMoreDescription: {},
      editingRowId: null, // currently editing row id
      editableCopy: {}, // to store temporary editable data
    };
  },
  async mounted() {
    this.idtoken = store.getters.getIdToken;
    await this.getRactData();
    window.addEventListener("studyIdChanged", async () => {
      await this.getRactData();
    });
    
  },
  methods: {
    //         document.addEventListener("DOMContentLoaded", function () {
    //   // const fileInput = document.getElementById('fileInput');
    //   // const dropArea = document.getElementById('dropArea');
    //   // const filePreview = document.getElementById('filePreview');
    //   // const fileName = document.getElementById('fileName');
    //   // const fileSize = document.getElementById('fileSize');
    //   // const validationResult = document.getElementById('validationResult');
    //   // const uploadBtn = document.getElementById('uploadBtn');
    //   // const btnText = document.getElementById('btnText');
    //   // const btnSpinner = document.getElementById('btnSpinner');
    //   // const uploadPanel = document.getElementById('uploadPanel');
    //   // const successPanel = document.getElementById('successPanel');
    //   const dataGrid = document.getElementById("dataGrid");
    //   const ractDataBody = document.getElementById("ractDataBody");
    //   const saveChangesBtn = document.getElementById("saveChangesBtn");
 
    //   // Open file browser when clicking on drop area or button
    //   // dropArea.addEventListener('click', (e) => {
    //   //     fileInput.click();
    //   // });
 
    //   // Handle file selection
    //   // fileInput.addEventListener('change', function() {
    //   //     if (this.files && this.files[0]) {
    //   //         handleFile(this.files[0]);
    //   //     }
    //   // });
 
    //   // Drag and drop events
    //   // ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
    //   //     dropArea.addEventListener(eventName, preventDefaults, false);
    //   // });
 
    //   // function preventDefaults(e) {
    //   //     e.preventDefault();
    //   //     e.stopPropagation();
    //   // }
 
    //   // ['dragenter', 'dragover'].forEach(eventName => {
    //   //     dropArea.addEventListener(eventName, highlight, false);
    //   // });
 
    //   // ['dragleave', 'drop'].forEach(eventName => {
    //   //     dropArea.addEventListener(eventName, unhighlight, false);
    //   // });
 
    //   // function highlight() {
    //   //     dropArea.classList.add('dragover');
    //   // }
 
    //   // function unhighlight() {
    //   //     dropArea.classList.remove('dragover');
    //   // }
 
    //   // // Handle dropped files
    //   // dropArea.addEventListener('drop', function(e) {
    //   //     const dt = e.dataTransfer;
    //   //     const file = dt.files[0];
    //   //     handleFile(file);
    //   // });
 
    //   // Process selected file
    //   // function handleFile(file) {
    //   //     // Check if file is Excel
    //   //     if (!file.name.match(/\.(xlsx|xls)$/i)) {
    //   //         showValidation('Only Excel files are allowed (.xlsx, .xls)', 'danger');
    //   //         return;
    //   //     }
 
    //   //     // Update file preview
    //   //     fileName.textContent = file.name;
    //   //     fileSize.textContent = formatFileSize(file.size);
    //   //     filePreview.classList.remove('d-none');
 
    //   //     // Show validation status
    //   //     showValidation('File selected. Ready for validation.', 'info');
 
    //   //     // Enable upload button
    //   //     uploadBtn.disabled = false;
    //   // }
 
    //   // Format file size
    //   // function formatFileSize(bytes) {
    //   //     if (bytes === 0) return '0 Bytes';
    //   //     const k = 1024;
    //   //     const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    //   //     const i = Math.floor(Math.log(bytes) / Math.log(k));
    //   //     return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    //   // }
 
    //   // Show validation message
    //   // function showValidation(message, type) {
    //   //     let icon = 'fa fa-info-circle';
    //   //     let heading = 'Information';
 
    //   //     if (type === 'success') {
    //   //         icon = 'fa fa-check-circle';
    //   //         heading = 'Success!';
    //   //     } else if (type === 'danger') {
    //   //         icon = 'fa fa-exclamation-circle';
    //   //         heading = 'Error!';
    //   //     }
 
    //   //     validationResult.className = `validation-result alert alert-${type} d-flex align-items-center`;
    //   //     validationResult.innerHTML = `
    //   //         <i class="fa ${icon} me-3" style="font-size: 1.5rem;"></i>
    //   //         <div>
    //   //             <h5 class="alert-heading">${heading}</h5>
    //   //             <p class="mb-0">${message}</p>
    //   //         </div>
    //   //     `;
    //   //     validationResult.classList.remove('d-none');
    //   // }
 
    //   // Upload button click handler
    //   // uploadBtn.addEventListener('click', function() {
    //   //     if (!fileInput.files.length) {
    //   //         showValidation('Please select a RACT file first', 'danger');
    //   //         return;
    //   //     }
 
    //   //     // Show loading state
    //   //     btnText.classList.add('d-none');
    //   //     btnSpinner.classList.remove('d-none');
    //   //     uploadBtn.disabled = true;
 
    //   //     // Simulate validation process
    //   //     setTimeout(() => {
    //   //         // Randomly determine if validation passes (80% success rate)
    //   //         const isValid = Math.random() > 0.2;
 
    //   //         if (isValid) {
    //   //             showValidation('RACT file validated successfully! Risk categories extracted.', 'success');
 
    //   //             // After successful validation, show the data grid
    //   //             setTimeout(() => {
    //   //                 // Hide upload panel
    //   //                 uploadPanel.classList.add('d-none');
 
    //   // Show success panel and data grid
    //   // successPanel.classList.remove('d-none');
    //   dataGrid.style.display = "block";
 
    //   // Populate the table with sample data
    //   populateDataGrid();
    //   //             }, 1000);
    //   //         } else {
    //   //             showValidation('Invalid RACT format. Please upload a valid TransCelerate RACT Excel file.', 'danger');
    //   //         }
 
    //   //         // Reset button state
    //   //         btnText.classList.remove('d-none');
    //   //         btnSpinner.classList.add('d-none');
    //   //         uploadBtn.disabled = false;
    //   //     }, 2000);
    //   // });
 
    //   // Save changes button handler
    //   saveChangesBtn.addEventListener("click", function () {
    //     const saveBtn = "";
    //     const originalText = saveBtn.innerHTML;
 
    //     saveBtn.innerHTML =
    //       '<span class="spinner-border spinner-border-sm me-2"></span>Saving changes...';
    //     saveBtn.disabled = true;
 
    //     // Simulate saving data to server
    //     setTimeout(() => {
    //       alert("All changes have been saved successfully!");
    //       saveBtn.innerHTML = originalText;
    //       saveBtn.disabled = false;
    //     }, 1500);
    //   });
 
    //   // Disable button initially
    //   // uploadBtn.disabled = true;
 
    //   // Sample RACT data
    //   const ractData = [
    //     {
    //       id: "RACT-001",
    //       category: "Safety",
    //       subcategory: "Adverse Events",
    //       description: "Unreported SAEs",
    //       scrutiny: "Site Level",
    //       riskLevel: "High",
    //     }
    //   ];
 
    //   // Function to populate the data grid
    //   function populateDataGrid() {
    //     ractDataBody.innerHTML = "";
 
    //     ractData.forEach((item) => {
    //       const row = document.createElement("tr");
 
    //       // Get risk level class for styling
    //       let riskClass = "risk-low";
    //       if (item.riskLevel === "Medium") riskClass = "risk-medium";
    //       if (item.riskLevel === "High") riskClass = "risk-high";
 
    //       row.innerHTML = `
    //                         <td class="py-0">${item.id}</td>
    //                         <td class="editable-cell py-1" contenteditable="true">${
    //                           item.category
    //                         }</td>
    //                         <td class="editable-cell py-1" contenteditable="true">${
    //                           item.subcategory
    //                         }</td>
    //                         <td class="editable-cell py-1" contenteditable="true">${
    //                           item.description
    //                         }</td>
    //                         <td class="editable-cell py-1" contenteditable="true">${
    //                           item.scrutiny
    //                         }</td>
    //                         <td class="py-1">
    //                             <select class="form-select form-select-sm risk-level-select ${riskClass}">
    //                                 <option ${
    //                                   item.riskLevel === "Low" ? "selected" : ""
    //                                 }>Low</option>
    //                                 <option ${
    //                                   item.riskLevel === "Medium" ? "selected" : ""
    //                                 }>Medium</option>
    //                                 <option ${
    //                                   item.riskLevel === "High" ? "selected" : ""
    //                                 }>High</option>
    //                             </select>
    //                         </td>
    //                         <td class="action-buttons py-1">
    //                             <button class="btn text-danger py-0">
    //                                 <i class="fa fa-trash"></i>
    //                             </button>
    //                         </td>
    //                     `;
 
    //       ractDataBody.appendChild(row);
    //     });
 
    //     // Add event listeners to risk level dropdowns
    //     document.querySelectorAll(".risk-level-select").forEach((select) => {
    //       select.addEventListener("change", function () {
    //         // Remove all risk classes
    //         this.classList.remove("risk-low", "risk-medium", "risk-high");
 
    //         // Add the appropriate class
    //         if (this.value === "Low") this.classList.add("risk-low");
    //         if (this.value === "Medium") this.classList.add("risk-medium");
    //         if (this.value === "High") this.classList.add("risk-high");
    //       });
    //     });
 
    //     // Make editable cells work better
    //     document.querySelectorAll(".editable-cell").forEach((cell) => {
    //       cell.addEventListener("focus", function () {
    //         this.dataset.originalValue = this.textContent;
    //       });
 
    //       cell.addEventListener("blur", function () {
    //         if (this.textContent !== this.dataset.originalValue) {
    //           this.classList.add("table-warning");
    //         }
    //       });
    //     });
    //   }
    // });
    async saveClicked() {
      if (this.editingRowId) {
        this.saveEdit(this.editingRowId);
      } else {
        await this.createRisk();
      }
    },
    async updatedClicked() {
      if (this.editingRowId) {
        this.updateRisk(this.editingRowId); 
       
        this.closeModal();

      } 
    },
    async updateRisk (id) {
      try {
      const idtoken = store.getters.getIdToken;
      // Build payload based on API model
      const payload = {
        id: id,
        studyId: store.getters.getStudyIs,
        siteId: "",
        siteCode: "",
        categoryId: this.value.categoryId,
        category: this.value.category,
        subCategory: this.value.subCategory,
        dataScope: "",
        dataScopeId: "",
        version: "",
        riskIndicator: "",
        discussionDetails: this.value.discussionDetails,
        coreOrExtendedKRI: "",
        generalOrSpecific: "",
        levelOfScrutiny: this.value.levelOfScrutiny,
        frequency: "",
        thresholdBasis: "",
        weighting: "",
        mitigationActions: "",
        phase: "",
        typeOfRisk: "",
        objectives: "",
        templateId: "",
        impactPoint: 0,
        probabilityPoint: 0,
        detectabilityPoint: 0,
        scorecard: "",
        riskLevelLabel: "",
        riskLevelColor: ""
      };
      const response = await axios.put(
        `${this.baseurl}/forms/rbqm/update`,
        payload,
        {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
        }
      );
      
      this.closeModal();
      alert("Key Risk Indicator updated successfully");
      this.saveEdit(this.editingRowId);
      await this.getRactData();
      } catch (err) {
      console.error("Error updating risk assessment:", err);
      alert("Failed to update Key Risk Indicator");
      }
    },
    async createRisk () {
      try {
      const idtoken = store.getters.getIdToken;
      // Build payload based on API model
      const payload = {
        studyId: store.getters.getStudyIs,
        siteId: "",
        siteCode: "",
        categoryId: this.value.categoryId,
        category: this.value.category,
        subCategory: this.value.subCategory,
        dataScope: "",
        dataScopeId: "",
        version: "",
        riskIndicator: "",
        discussionDetails: this.value.discussionDetails,
        coreOrExtendedKRI: "",
        generalOrSpecific: "",
        levelOfScrutiny: this.value.levelOfScrutiny,
        frequency: "",
        thresholdBasis: "",
        weighting: "",
        mitigationActions: "",
        phase: "",
        typeOfRisk: "",
        objectives: "",
        templateId: "",
        impactPoint: 0,
        probabilityPoint: 0,
        detectabilityPoint: 0,
        scorecard: "",
        riskLevelLabel: "",
        riskLevelColor: ""
      };
      const response = await axios.post(
        `${this.baseurl}/forms/rbqm/create`,
        payload,
        {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
        }
      );
      await this.getRactData();
      this.closeModal();
      alert("Key Risk Indicator created successfully");
      } catch (err) {
      console.error("Error saving risk assessment:", err);
      alert("Failed to create Key Risk Indicator.");
      }
    },
    async EditRact(id) {
      try {
      this.editRiskModal = true;
      this.editingRowId = id;
      const idtoken = store.getters.getIdToken;
      const response = await axios.get(
        `${this.baseurl}/forms/rbqm/getriskindicator?id=${id}`,
        {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
        }
      );
      this.editableCopy = JSON.parse(JSON.stringify(response.data));
      this.value = {
        categoryId: response.data.categoryId || "",
        category: response.data.category || "",
        subCategory: response.data.subCategory || "",
        levelOfScrutiny: response.data.levelOfScrutiny || "",
        discussionDetails: response.data.discussionDetails || "",
      };
      } catch (err) {
      console.error("Error fetching risk indicator:", err);
      alert("Failed to fetch risk indicator data.");
      }
    },
    saveEdit(id) {
      const index = this.ractlist.findIndex((item) => item.id === id);
      if (index !== -1) {
        this.ractlist.splice(index, 1, { ...this.editableCopy });
      }
      this.editingRowId = null;
      this.editableCopy = {};
    },
    cancelEdit() {
      this.editingRowId = null;
      this.editableCopy = {};
    },
    async openCreateRiskModals() {
      this.openCreateRiskModal = true;
    
    },  
    async clear () {
      this.value = {
        category: "",
        subCategory: "",
        levelOfScrutiny: "",
        discussionDetails: "",
      };
    },
    async closeModal() {
      this.value={
        category: "",
        subCategory: "",
        levelOfScrutiny: "",
        discussionDetails: "",
 
      }
      this.openCreateRiskModal = false;
      this.editRiskModal = false;
    },
    async getRactData() {
      const idtoken = store.getters.getIdToken;
     
      await axios
        .get(
          ` ${this.baseurl}/forms/rbqm/paginatedindicator?` +
            "&pageindex=" +
            this.currentTemplatePage +
            "&pagesize=" +
            this.pagesize +
            "&StudyId=" +
            store.getters.getStudyIs +
            "&SortProperty=" +
            this.SortProperty +
            "&SortOrder=" +
            this.SortOrder,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.ractlist = res.data.entities;
          this.totalCount = res.data.totalCount;
          this.totalTemplatePages = Math.ceil(this.totalCount / this.pagesize);
        })
        .catch((err) => {
          console.log("error..", err);
        });
    },
    LoadData: function (page) {
      this.currentTemplatePage = page;
      this.getRactData();
    },
  },
};
</script>
 
  <style scoped>
.dark-table-head > thead {
  --bs-table-accent-bg: hsl(205, 72%, 37%) !important;
  color: #ffffff !important;
}
 
:root {
  --primary: #1a6aa2;
  --secondary: #28a745;
  --light-bg: #f8f9fa;
  --card-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  --border-radius: 10px;
  --success-bg: #d4edda;
  --success-border: #c3e6cb;
}
 
.header-icon {
  background: #1a6aa2;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}
 
.upload-container {
  width: 100%;
  margin: 1rem auto;
}
 
.upload-card {
  background: white;
  border-radius: var(--border-radius);
  box-shadow: var(--card-shadow);
  overflow: hidden;
  border: none;
  margin-bottom: 0.5rem;
}
 
.card-header {
  background: #1a6aa2;
  color: white;
  padding: 1.5rem;
  border-bottom: 3px solid rgba(255, 255, 255, 0.2);
}
 
.card-body {
  padding: 2rem;
}
 
.upload-icon {
  font-size: 1rem;
  color: #1a6aa2;
  margin-bottom: 1.5rem;
}
 
.file-drop-area {
  border: 2px dashed #ced4da;
  border-radius: var(--border-radius);
  padding: 0.5rem 1rem;
  text-align: center;
  background: #f8f9fa;
  transition: all 0.3s;
  margin-bottom: 0.5rem;
  cursor: pointer;
}
 
.file-drop-area:hover,
.file-drop-area.dragover {
  border-color: var(--primary);
  background-color: rgba(26, 106, 162, 0.05);
}
 
.file-drop-area i {
  font-size: 0.8rem;
  color: #6c757d;
}
 
.file-preview {
  background: #e9f7fe;
  border-radius: var(--border-radius);
  padding: 0.5rem;
  display: flex;
  align-items: center;
  margin-top: 0.5rem;
}
 
.file-icon {
  font-size: 1rem;
  color: var(--primary);
  margin-right: 1rem;
}
 
.file-info h5 {
  margin-bottom: 0.25rem;
  color: #212529;
}
 
.file-info p {
  margin-bottom: 0;
  color: #6c757d;
}
 
.validation-result {
  padding: 1rem;
  border-radius: var(--border-radius);
  margin-top: 0.5rem;
}
 
.btn-upload {
  background: var(--primary);
  border: none;
  padding: 0.1rem 1rem;
  font-size: 0.8rem;
  font-weight: 500;
  transition: all 0.3s;
  color: #ffffff;
}
 
.btn-upload:hover {
  background: #0095ff;
  transform: translateY(-2px);
}
 
.btn-upload:active {
  transform: translateY(0);
}
 
.ract-info {
  background: #f8f9fa;
  border-radius: var(--border-radius);
  padding: 1.5rem;
  margin-top: 2rem;
}
 
.info-icon {
  color: var(--primary);
  font-size: 1.25rem;
  margin-right: 0.5rem;
}
 
.step-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--primary);
  color: white;
  font-weight: bold;
  margin-right: 10px;
}
 
.footer {
  text-align: center;
  padding: 1rem 0;
  color: #6c757d;
  font-size: 0.9rem;
  margin-top: 2rem;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}
 
.spinner-border {
  width: 1.2rem;
  height: 1.2rem;
  border-width: 0.15em;
  margin-right: 0.5rem;
}
 
.data-grid-container {
  /* display: none; */
  display: block;
  margin-top: 1rem;
}
 
.data-grid-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
  padding: 0.25rem 0rem;
}
 
.table-responsive {
  border-radius: var(--border-radius);
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: middle;
  border-color: #dee2e6;
}
.thead-primary {
  background-color: #0095ff !important;
  color: #ffffff !important;
}
.table-hover tbody tr:hover {
  background-color: rgba(209, 236, 255, 0.05);
}
 
.table .editable-cell {
  cursor: pointer;
  position: relative;
  outline: none !important;
}
 
.table .editable-cell:hover {
  background-color: rgba(255, 255, 0, 0.1);
}
 
.table .editable-cell:focus {
  background-color: rgba(255, 255, 0, 0.171);
  outline: none !important;
  box-shadow: none !important;
}
 
.action-buttons {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
}
 
.btn-save {
  background: var(--secondary);
  border: none;
  padding: 0.1rem 0.5rem;
}
 
.btn-save:hover {
  background: #218838;
}
 
.success-panel {
  background: var(--success-bg);
  border: solid var(--success-border);
  border-radius: var(--border-radius);
  margin-bottom: 1rem;
}
.cancel_btn {
  padding: 0.43rem 0.4rem;
  border-radius: 0.25rem;
}
 
.status-badge {
  padding: 0.1rem 1rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.9rem;
}
 
.status-active {
  background: #d4edda;
  color: #155724;
}
 
.status-pending {
  background: #fff3cd;
  color: #856404;
}
 
.risk-low {
  background: #d4edda;
  color: #155724;
}
 
.risk-medium {
  background: #fff3cd;
  color: #856404;
}
 
.risk-high {
  background: #f8d7da;
  color: #721c24;
}
 
.risk-cell {
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  display: inline-block;
  font-weight: 500;
  text-align: center;
  min-width: 80px;
}
.form-select-sm {
  padding: 0.15rem 0.5rem !important;
  font-size: 0.7rem !important;
}
.more-block {
  color: blue;
  cursor: pointer;
}
</style>
 